import { createApp } from 'vue'

import prototypes from '@/extensions/prototypes/prototypes'
import '@/extensions/filters/filters'

import store from '@/store'
import router from '@/router'
import App from '@/components/pages/general/App.vue'
import Default from '@/components/layouts/Default'
import SuperAdmin from '@/components/layouts/SuperAdmin'
import Empty from '@/components/layouts/Empty'
import { VueHeadMixin, createHead } from '@unhead/vue'
import ApiService from "@/services/api.service"
import { getApiUrl } from "@/services/env.helper"
import noty from '@/extensions/plugins/noty'
import ExpandableImage from '@/components/parts/general/ExpandableImage.vue'
import VueDOMPurifyHTML from 'vue-dompurify-html'
import "regenerator-runtime"
import axios from "axios"
import appVersion from "@/version.json"

const app = createApp(App)

app.component('default-layout', Default)
app.component('super_admin-layout', SuperAdmin)
app.component('empty-layout', Empty)
app.component('expandable-image', ExpandableImage)

import { installErrorReporter } from "@/services/errorReporter"
installErrorReporter(app, store) // browser errors -> backend -> telegram (production only)

app.use(prototypes)
app.use(noty, {
  timeout: 3000,
  progressBar: false,
  layout: 'bottomRight'
})

// own replacements of bootstrap-vue's components and directives
import bootstrapReplacements from '@/components/bootstrap/install'
app.use(bootstrapReplacements)

const head = createHead()
app.mixin(VueHeadMixin)
app.use(head)
app.use(VueDOMPurifyHTML)

import clickOutside from '@/extensions/directives/v-click-outside'
import spaceduckCollapse from '@/extensions/directives/spaceduck-collapse'
app.directive('click-outside', clickOutside)
app.directive('spaceduck-collapse', spaceduckCollapse)

import i18n from '@/lang/i18n'
// Vue.config.productionTip = false

import { installMetrika } from '@/services/metrika'
installMetrika(router)

ApiService.init(i18n, router, app)

window.localStorage.setItem('lastUpdate', Date.now())

const init = () => {
  app.use(i18n).use(router).use(store).mount('#app')
  import("@/extensions/firebase/firebase") // analytics, after the app is up
  console.log(`===== %cApp version: ${appVersion.version}%c =====`, "color: #ffffff; background-color: #0787C9; padding: 4px; border-radius: 4px; font-size: 10px; font-weight: normal;", "")
}

window.addEventListener("flutterInAppWebViewPlatformReady", function() {
  store.commit('setFlutterApp', true)
})

if(window?.location?.origin.includes('my.dentist-plus.com')) {
  axios.defaults.baseURL = getApiUrl()
  store.commit('setUseProxy', false)
}

if(store.state.auth.isLogged) {
  store.dispatch('init').then(() => {
    init()
  }).catch(() => {
    // store.dispatch('logout')
  })
} else {
  init()
}


